import { InputTextMaster, MasterButton, Modal } from "App/Component/ui";
import { Grid } from "@material-ui/core";
import { useContext, useState } from "react";
import { FormContext } from "../../context/FormContext";
import {
  DEFAULT_SHOW_BUTTON_SUBMIT,
  DISABLED_BUTTON_SUBMIT,
} from "App/constants";

const ModalTax = ({ setShowModal, setNewDataPoList, listPO }) => {
  const [disabled, setDisabled] = useState(DEFAULT_SHOW_BUTTON_SUBMIT);
  const { formData, setFormData } = useContext(FormContext);
  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisabled(DISABLED_BUTTON_SUBMIT);
    setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
    setShowModal(false);
    // try {
    //   if (formData.date === "") {
    //     defaultToastError("Tanggal tidak boleh kosong!");
    //   } else {
    //     const api = await instance4.post(urlUpdatePO, {
    //       id: formData.idpo,
    //       date: formData.date,
    //       gudang_id: formData.gudang_id,
    //       supplier_id: formData.supplier_id,
    //       penerima: formData.penerima,
    //       catatan: formData.remark,
    //       namaPO: "",
    //       tax: formData.tax,
    //       data:listPO,
    //     });
    //     const res = await api?.data;
    //     if (res.status === 200) {

    //       defaultToastSuccess(res?.message);
    //       await setNewDataPoList();
    //       // const res = await getPoListById(formData.idpo);
    //       // setListPO(res.data);
    //     } else {
    //       setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
    //       defaultToastError(res?.message);
    //     }
    //   }
    // } catch (error) {
    //   setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
    //   defaultToastError(error?.response?.data?.message);
    // }
  };

  const handleChange = (text) => (e) => {
    setFormData({
      ...formData,
      [text]: e.target.value,
    });
  };

  return (
    <Modal title={`Tax`} show={setShowModal}>
      <form action="POST" onSubmit={(e) => handleSubmit(e)}>
        <Grid container spacing={1}>
          <Grid item sm={12}>
            <InputTextMaster
              name="tax"
              label="TAX %"
              id="tax"
              type="number"
              value={formData.tax}
              onChange={handleChange("tax")}
              placeholder="0"
            />
          </Grid>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="flex-end"
          alignItems="center"
        >
          <MasterButton
            className={"mt-1"}
            type="submit"
            color={disabled.color}
            name={disabled.label}
            disabled={disabled.disabled}
            size="md"
          />
        </Grid>
      </form>
    </Modal>
  );
};

export default ModalTax;
